import throttle from 'lodash/throttle'
import {linksHandler} from './modals.js'


// INIT FUNCTION
export default function headerScripts() {
    const topCircle = document.getElementsByClassName('background-circle ')[0]
    const headerBlockImage = document.getElementsByClassName(
      'top-circle-image',
    )[0]
    const input = document.getElementsByClassName(
      'site-header__search__input',
    )[0]
    const header = document.getElementsByClassName('site-header')[0]
    const hamburger = header.getElementsByClassName('site-header__hamburger')
    
    if (headerBlockImage) {
        positionTopCircle(headerBlockImage, topCircle)
    } else {
        topCircle.classList.add('visible-without-positioning')
    }
    
    changeHeaderOnScroll(header)
    if (hamburger.length) {
        hamburger[0].addEventListener('click', () =>
          hamburger[0].classList.toggle('is-active'),
        )
    }
    
    searchAnimations(input);
    input.addEventListener('input', throttle(searchRequest, 500));
}


//CHANGE HEADER HEIGHT
function changeHeaderOnScroll(header) {
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    }
    
    const changeHeaderClass = (className, entry) => {
        if (!entry.isIntersecting) {
            header.classList.add(className)
        } else {
            header.classList.remove(className)
        }
    }
    
    const classSwitcher = (entries, observer) => {
        entries.map(entry => {
            // header change point intersection
            if (entry.target.className === 'header-minimizer-mark') {
                changeHeaderClass('shrink', entry)
            }
        })
    }
    
    const headerChangePoint = document.getElementsByClassName(
      'header-minimizer-mark',
    )[0]
    
    const observer = new IntersectionObserver(classSwitcher, options)
    observer.observe(headerChangePoint)
}

//ELEMENTS ANIMATIONS
function searchAnimations(input) {
    const siteContainer = document.getElementsByClassName('site-content')[0]
    const resultContainer = document.getElementsByClassName(
      'site-header__search__result-container',
    )[0]
    const closeResults = resultContainer.getElementsByClassName(
      'site-header__search__result-close',
    )[0]
    
    const removeFocus = () =>
      !input.value ? input.classList.remove('focused') : ''
    
    const closeSearch = e => {
        e.preventDefault()
        resultContainer.classList.remove('showing')
        input.value = ''
        removeFocus()
    }
    
    if (input.value) {
        input.classList.add('focused')
    }
    
    input.addEventListener('focus', () => {
        input.classList.add('focused')
    })
    
    input.addEventListener('blur', removeFocus)
    closeResults.addEventListener('click', closeSearch)
    siteContainer.addEventListener('click', () =>
      resultContainer.classList.remove('showing'),
    )
}

// CREATE SEARCH RESULT LINK
function createLinkElement(pages, name) {
    if (!pages || !pages.length) {
        return ''
    }
    return `
    <div class="site-header__search__item">
      <h4>${name}</h4>
      ${pages.reduce((res, el) => {
        return `
          ${res}
          <a href="${name !== 'Konsulter' ? el.link : '#'}"
            data-id="${el.id}"
            data-type="${name === 'Konsulter' ? 'employee' : ''}"
            class="site-header__search__link ${
          name === 'Konsulter' ? 'modal-link' : ''
        }"
            target="${name !== 'Pages' ? '_blank' : ''}">
            ${el.title}
          </a>`
    }, '')}
    </div>
  `
}

// SEARCH REQUEST
function searchRequest({ target }) {
    const resultContainer = document.getElementsByClassName(
      'site-header__search__result-container',
    )[0]
    const searchResult = resultContainer.getElementsByClassName(
      'site-header__search__result',
    )[0]
    
    if (target.value.length >= 2) {
        const { value } = target
        target.classList.add('requesting')
        
        jQuery
          .ajax({
              method: 'POST',
              url: window.MS_Ajax.ajaxurl,
              data: {
                  action: 'search-ajax',
                  searchString: value,
              },
          })
          .done(data => {
              const result =
                createLinkElement(data.page, 'Sidor') +
                createLinkElement(data.attachment, 'Filer') +
                createLinkElement(data.employees, 'Konsulter')
              searchResult.innerHTML = result || 'Inget hittades'
              
              if (result) {
                  const links = [].slice.apply(searchResult.querySelectorAll('.modal-link'))
                  linksHandler(links)
              }
              resultContainer.classList.add('showing')
              target.classList.remove('requesting')
          })
    } else {
        resultContainer.classList.remove('showing')
    }
}

// PLACE TOP CIRCLE PRECISELY BEHIND THE IMAGE
function positionTopCircle(img, circle) {
    const {
        width,
        height,
        offsetTop,
        offsetLeft,
    } = img
    circle.style.top = `${offsetTop + height / 2}px`
    circle.style.left = `${offsetLeft + width / 2}px`
    circle.style.width = `${width * 2.012}px`
    circle.classList.add('visible')
}